import calls from '@/backend/api-calls'
import filters from '@/filters'

const state = {
  users: [],
  selected: [],
  allSelected: false,
  loading: false,
  roles: [],
  filters: { 
    display_name: null,
    is_active: 'true',
    role: null,
    policy: null
  },
  orderBy: {
    default: { field: 'display_name', direction: 'asc' },
    current: { field: 'display_name', direction: 'asc' },
  },
  statusOptions: [
    { name: 'Active', value: 'true' },
    { name: 'Inactive', value: 'false' }
  ]
}

const getters = {
  filteredUserList: state => {
    let userList = state.users;
    let { display_name, is_active, role, policy } = state.filters;
    let { field, direction } = state.orderBy.current;
    
    // filter by status
    if (is_active != '' && is_active != undefined) {
      userList = userList.filter(user => {
        return user.is_active.toString() == is_active;
      });
    }

    // filter by name
    if (display_name != '' && display_name != undefined) {
      userList = userList.filter(user => {
        return user.display_name.toString().toUpperCase().includes(display_name.toString().toUpperCase());
      });
    }

    // filter by role
    if (role != '' && role != undefined && role != null) {
      userList = userList.filter(user => {
        if (user.role) return user.role.toString().toUpperCase() === role.toString().toUpperCase();
      });
    }

    // filter by policy
    if (policy != '' && policy != undefined && policy != null) {
      userList = userList.filter(user => {
        if (user.policy) return user.policy.id == policy;
      });
    }

    // sorting
    userList.sort((a, b) => {
      let y = (a[field] || '').toString().toUpperCase();
      let z = (b[field] || '').toString().toUpperCase();

      let result = (y < z) ? -1 : (y > z) ? 1 : 0;

      return result * (direction === 'desc' ? -1 : 1);
    });

    return userList;
  },
  roles() {
    return [...new Set(
      state.users.map(d => d.role ? filters.Titlecase(
        d.role.replaceAll("_", " ")
      ) : null).filter(d => !!d)
    )].sort()
  },
  ids() {
    return state.users.map(d => d.id);
  },
  selectedUsers() {
    return state.users.filter(d => state.selected.includes(d.id));
  }
}

const actions = {
  addUser({commit}, data) {
    return new Promise((resolve, reject) => {
      calls.admin.registerUser(data)
        .then(resp => {
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'User successfully added'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    });
  },
  updateUser: ({commit}, { id, data}) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.user.put(id, data).then(resp => {
        commit("app/setNotification", {
          type: 'success',
          status: true,
          message: 'User successfully updated'
        }, { root: true });
        commit("insertUpdatedUser", resp.data);
        commit("setLoading", false);
        resolve(resp);
      }).catch(err => {
        commit("setLoading", false);
        reject(err)
      });
    })
  },
  getUsers: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.users.get(parameters).then(resp => {
        commit("setUsers", resp.data);
        commit("setLoading", false);
        resolve(resp);
      }).catch(err => {
        commit("setLoading", false);
        reject(err)
      });
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.filteredUserList);
    } else {
      commit("deselectAll");
    }
  }
}

const mutations = {
  insertUser(state, data) {
    state.users.push(data);
  },
  setUsers: (state, data) => {
    state.users = data;
  },
  insertUpdatedUser (state, data) {
    state.users.forEach((user, i) => {
      if (user.id == data.id) {
        state.users.splice(i, 1, data);
      }
    })
  },
  setLoading(state, status) {
    state.loading = status;
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  setOrderBy(state, { field, direction }) {
    if (!field || (field == state.orderBy.current.field && direction == state.orderBy.current.direction)) {
      state.orderBy.current.field = state.orderBy.default.field;
      state.orderBy.current.direction = state.orderBy.default.direction;
    } else state.orderBy.current = { field, direction };
  },
  selectAll(state, filteredUsers) {
    state.allSelected = true;
    let ids = filteredUsers.map(d => d.id);
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
